module.exports = __webpack_public_path__ + "assets/img/inspection.c5199c53.svg";